import {NgModule} from '@angular/core';
import {SearchComponent} from './search.component';
import {CommonModule} from '@angular/common';
import {ButtonModule} from 'primeng/button';
import {ToggleButtonModule} from 'primeng/togglebutton';
import {FormsModule} from '@angular/forms';
import {OverlayPanelModule} from 'primeng/overlaypanel';
import {SearchSettingsComponent} from './search-settings/search-settings.component';
import {SearchCaseCardComponent} from './cards/search-case-card/search-case-card.component';
import {SearchBaseCardComponent} from './cards/search-base-card.component';
import {SearchOrganizationCardComponent} from './cards/search-organization-card/search-organization-card.component';
import {RouterModule} from '@angular/router';
import { SearchPatientFileCardComponent } from './cards/search-patient-file-card/search-patient-file-card.component';

@NgModule({
  declarations: [
    SearchComponent,
    SearchSettingsComponent,

    SearchBaseCardComponent,
    SearchCaseCardComponent,
    SearchOrganizationCardComponent,
    SearchPatientFileCardComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ButtonModule,
    ToggleButtonModule,
    OverlayPanelModule,
  ],
  exports: [
    SearchComponent,
  ]
})
export class SearchModule {
}
